import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IProjectName } from '../types/IProject';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetProjectNamesResult extends IGetItemsResult {
  projects: IProjectName[];
}

export class GetProjectNamesRequest extends Request<IGetItemsParams, IGetProjectNamesResult> {
  constructor(params: IGetItemsParams) {
    super('getProjectNames', params);
  }
}
